export const removeFieldError = (field, errors, wrapperSelector, errorDivClass = 'is_error') => {
  const parentWrapper = field.closest(wrapperSelector);
  let errorClasses = [];
  let successClasses = [];
  // Fehler aus der Fehlerliste entfernen
  const errorIndex = errors.findIndex(err => err.field === field);
  if (errorIndex !== -1) {
    errorClasses = errors[errorIndex]?.wrapperErrorClasses;
    successClasses = errors[errorIndex]?.wrapperSuccessClasses;
    errors.splice(errorIndex, 1);
  }
  // Fehleranzeige entfernen
  field.classList.remove('error');
  if (parentWrapper) {
    const errorDiv = parentWrapper.querySelector(`.${errorDivClass}`);
    errorClasses && parentWrapper.classList.remove(...errorClasses);
    successClasses && parentWrapper.classList.add(...successClasses);
    if (errorDiv) {
      errorDiv.remove();
    }
  }
};
